import React from 'react';
import PropTypes from 'prop-types';
import styles from './Switch.module.css';


const Toggle = ({ on, onClick, disabled, ariaLabel }) => {
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? () => {} : onClick}
      onKeyDown={handleKeyDown}
      className={[
        styles.switchContainer,
        disabled ? styles.switchContainerDisabled : null,
        on ? styles.switchContainerOn : null,
        'dark:border-darkElevationPrimary border-border border-[1px]'
      ].join(' ')}
    >
      <div className={[
        styles.switchToggle,
        on ? styles.switchOn : styles.switchOff
      ].join(' ')} 
      />
    </button>
  );
};

Toggle.propTypes = {
  on: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
}

Toggle.defaultProps = {
  disabled: false,
}

export default Toggle;
